module.exports = __webpack_public_path__ + "img/video_shrink_open.659fea5c.svg";